import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import {Link} from "react-router-dom";
import {
  InputAdornment,
  TextField
} from "@mui/material";
import { Search, SentimentDissatisfied } from "@mui/icons-material";

const Header = ({ children, hasHiddenAuthButtons }) => {

  console.log(" header ", hasHiddenAuthButtons);
  console.log(" localStorage username :: ", localStorage.getItem('username'));

    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
        
        <Box width={350}>
        {children}
        </Box>
        {/* {(searchBar !== false)?( <TextField
        className="search-desktop"
        fullWidth
        size="small"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
      />):("")} */}

      {(hasHiddenAuthButtons === false)?(
        <Link to="/" className="link">
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
        >
          Back to explore
        </Button>
        </Link>
      ) : ( !(localStorage.getItem('username'))?
     ( <Box>
        <Link to="/login" className="link">
          <Button
          className="explore-button"
          variant="text"
        >
         LOGIN
        </Button>
        </Link>
         {(" ")}
         <Link to="/register" className="link">
        <Button
          variant="contained"
        >
          REGISTER
        </Button>
        </Link>
        </Box>
     ) : (
      <Stack
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
      spacing={1}
    >
      <img src="avatar.png" alt={localStorage.getItem('username')}></img>
        <p>{localStorage.getItem('username')}</p>
         {(" ")}
         
        <Button onClick={()=>{
          localStorage.clear();
          window.location.reload();
        }}
        >
          LOGOUT
        </Button>
        </Stack>
     )
        )}


      </Box>
    );
};

export default Header;
